import React from 'react'

import { Tag } from 'rsuite'
import { formatBusinessProfileStatus } from '@@partner:helpers/formatters/businessProfile'

export interface CustomerStatusLabelProps {
  status: string
}

export default function BusinessProfileStatusLabel ({
  status
}: CustomerStatusLabelProps) {
  const { label, color } = formatBusinessProfileStatus(status)
  return (
    <Tag className="u-status-badge" color={color}>
      {label}
    </Tag>
  )
}
